import http from "./HttpService";

const endpoint = process.env.VUE_APP_BASE_URL;


export const updateOperationStatus = (data) => {
  return http.post('/Configs/temporaryDisabling', data, {
    baseURL: endpoint,
  });
};

export const fetchOperationStatus = () => {
  return http.get('/Configs/privates/users', {
    baseURL: endpoint,
  });
};

export const submitSuspiciousCryptoWalletsAddresses = (data) => {
  return http.post('/Configs/suspiciousCryptoWalletsAddresses', data, {
    baseURL: endpoint,
  });
};


